import DataTable from "react-data-table-component";
import moment from "moment";

const BackupLogsTable = ({ data, totalCount, handlePageChange,
    handlePerRowsChange }: {
        data: any, totalCount: number, handlePageChange: any,
        handlePerRowsChange: any
    }) => {

    const columns = [
        {
            name: "Type",
            selector: (row: any) => row?.type,
            sortable: true,
            grow: 6,
            wrap: true,
        },
        {
            name: "Size",
            cell: (row: any) => typeof row?.size === "number" ? `${Number(row?.size / 1024 / 1024).toFixed(4)} MB` : row?.size,
            sortable: true,
            grow: 6,
        },
        {
            name: "Status",
            cell: (row: any) => row?.status === "success" ? <span style={{ color: "green", }}>{row?.status}</span> : <span style={{ color: "red" }}>{row?.status}</span>,
            sortable: true,
            grow: 6,
        },
        {
            name: "Date",
            selector: (row: any) => moment(row?.createdAt).format("YYYY-MM-DD HH:mm:ss A"),
            sortable: true,
            grow: 6,
        },
    ];
    const paginationComponentOptions = {
        rowsPerPageText: "Rows Per Page",
        rangeSeparatorText: "of",
        selectAllRowsItem: true,
        selectAllRowsItemText: "Requests",
        styles: {
            background: "red",
        },
    };

    return (
        <>
            <DataTable
                columns={columns}
                data={data || []}
                pagination
                paginationServer
                paginationTotalRows={totalCount}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                paginationComponentOptions={paginationComponentOptions}
                customStyles={{
                    rows: {
                        style: {
                            minHeight: "60px",
                        },
                    },
                    headCells: {
                        style: {
                            fontSize: "14px",
                            fontWeight: "bold",
                        },
                    },
                    cells: {
                        style: {
                            fontSize: "14px",
                        },
                    },
                }}
            />
        </>
    );
};

export default BackupLogsTable;
